import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
  submitBox: {
    marginTop: '2rem',
  },
}));
